import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Lock, MessageCircle, XCircle } from 'lucide-react';
import { Button } from '../components/UI';

// /grupo/:token — link rastreado do grupo de WhatsApp entregue ao lead do quiz (tela de resultado,
// primeira mensagem do SDR e e-mails de nutrição). Registra o clique e redireciona para o grupo atual.
const GroupJoin: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const { t } = useTranslation();
  const [state, setState] = useState<'loading' | 'ready' | 'closed' | 'error'>('loading');
  const [url, setUrl] = useState('');
  const [slug, setSlug] = useState('');

  useEffect(() => {
    let cancelled = false;
    axios.post(`/landing-pages/group/${token}`)
      .then((res) => {
        if (cancelled) return;
        setSlug(res.data?.slug || '');
        if (res.data?.url) {
          setUrl(res.data.url);
          setState('ready');
          window.location.replace(res.data.url);
        } else if (res.data?.closed) {
          setState('closed');
        } else {
          setState('error');
        }
      })
      .catch(() => { if (!cancelled) setState('error'); });
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-16">
      <div className="card max-w-md w-full text-center">
        {state === 'closed' ? (
          <>
            <Lock className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2">{t('landingQuiz.groupJoin.closedTitle')}</h1>
            <p className="text-gray-600 mb-6">{t('landingQuiz.groupJoin.closedMessage')}</p>
            <Button to={slug ? `/l/${slug}` : '/'}>{t('landingQuiz.groupJoin.backHome')}</Button>
          </>
        ) : state === 'error' ? (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2">{t('landingQuiz.groupJoin.errorTitle')}</h1>
            <p className="text-gray-600 mb-6">{t('landingQuiz.groupJoin.errorMessage')}</p>
            <Button to={slug ? `/l/${slug}` : '/'}>{t('landingQuiz.groupJoin.backHome')}</Button>
          </>
        ) : (
          <>
            <MessageCircle className="w-12 h-12 text-[#25D366] mx-auto mb-4" />
            <p className="text-gray-900 font-semibold mb-2">{t('landingQuiz.groupJoin.loading')}</p>
            {state === 'ready' && (
              <>
                <p className="text-gray-600 mb-6">{t('landingQuiz.groupJoin.manual')}</p>
                <a
                  href={url}
                  className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5b] text-white font-semibold py-3 px-6 rounded-lg"
                >
                  <MessageCircle className="w-5 h-5" />
                  {t('landingQuiz.groupJoin.open')}
                </a>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default GroupJoin;
